var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 13.3327H11.6663M7.33301 18.3327H12.6663C14.0665 18.3327 14.7665 18.3327 15.3013 18.0602C15.7717 17.8205 16.1542 17.4381 16.3939 16.9677C16.6663 16.4329 16.6663 15.7328 16.6663 14.3327V5.66602C16.6663 4.26588 16.6663 3.56582 16.3939 3.03104C16.1542 2.56063 15.7717 2.17818 15.3013 1.9385C14.7665 1.66602 14.0665 1.66602 12.6663 1.66602H7.33301C5.93288 1.66602 5.23281 1.66602 4.69803 1.9385C4.22763 2.17818 3.84517 2.56063 3.60549 3.03104C3.33301 3.56582 3.33301 4.26588 3.33301 5.66602V14.3327C3.33301 15.7328 3.33301 16.4329 3.60549 16.9677C3.84517 17.4381 4.22763 17.8205 4.69803 18.0602C5.23281 18.3327 5.93288 18.3327 7.33301 18.3327ZM12.4997 7.49935C12.4997 8.88006 11.3804 9.99935 9.99967 9.99935C8.61896 9.99935 7.49967 8.88006 7.49967 7.49935C7.49967 6.11864 8.61896 4.99935 9.99967 4.99935C11.3804 4.99935 12.4997 6.11864 12.4997 7.49935Z",
    stroke: "#EBEBF5",
    strokeOpacity: 0.64,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.d637038db97f6f8d38018361545839e6.svg";
export { ForwardRef as ReactComponent };